import { useEffect, type RefObject } from 'react';

import { useCalendarContext } from './useCalendarContext.js';

export interface UseFocusProps {
  isFocused: boolean;
  itemRef: RefObject<HTMLDivElement | null> | undefined;
}

/** Custom hook that is used for focusing the active calendar view item. This is necessary for keyboard support. */
export function useFocus({ isFocused, itemRef }: UseFocusProps): {
  tabIndex: 0 | -1;
} {
  const { state } = useCalendarContext();

  // Waits for the tabIndex to be updated on the DOM and then focuses the element.
  useEffect(() => {
    // We only want to update when the calendar received a key press.
    state.shouldUpdateFocusFromKeydown &&
      isFocused &&
      itemRef?.current?.focus();
  }, [itemRef, isFocused, state.shouldUpdateFocusFromKeydown]);

  return { tabIndex: isFocused ? 0 : -1 };
}
